import {
  OwnerUser,
  Showroom,
  VehicleModelMinimal,
  VehicleVariantMinimal,
  Exterior,
  MediaFile,
  VehiclesAndCeilingPrice,
} from '.';

export enum DiscountTarget {
  Vehicle = 'Vehicle',
  Accessories = 'Accessories',
  TradeIn = 'TradeIn',
}

export enum DiscountMode {
  Cash = 'Cash',
  Pool = 'Pool',
  TradeIn = 'TradeIn',
}

export enum ConfigurationEntity {
  Accessories = 'Accessories',
  AccessoryPackages = 'AccessoryPackages',
  CustomerCare = 'CustomerCare',
  ExtendedWarranty = 'ExtendedWarranty',
  ServicePackage = 'ServicePackage',
  TPL = 'TPL',
  Registration = 'Registration',
  Insurance = 'Insurance',
  TradeIn = 'TradeIn',
  Finance = 'Finance',
  Addons = 'Addons',
}

export interface DiscountDocumentType {
  _id?: string;
  name: string;
  fileTypes: string[];
  mimeTypes?: string[];
}
export interface DiscountType {
  _id?: string;
  name: string;
  mode?: string;
  level: string;
  approverTypes: string[];
  requesterTypes: string[];
  doNotIncludeInNPC: boolean;
  autolineOptionCode: string;
  documents: string[];
  modelVariants: { modelCode: string; variantCode: string }[];
  requiredAnyOneDocument?: boolean;
  requiredDocuments?: string[];
  requiredEntities?: ConfigurationEntity[];
  hideMaxDiscountFromUI?: boolean;
  maxAllowedDiscountType: string;
  maxAllowedDiscountValue?: number;
  code?: string;
  avoidMaxDiscount?: boolean;
  discountMode?: string;
  enableEmailApproval?: boolean;
}

export enum DiscountApplicableOn {
  VIN = 'VIN',
  PreVIN = 'PreVIN',
  Both = 'Both',
}

export interface CashDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
  applicableOn: DiscountApplicableOn;
}

export interface CampaignCashDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
  applicableOn?: DiscountApplicableOn;
}

export interface CreateCampaignCashDiscountLimits {
  limits: DiscountLimits[];
  otpRequestId?: string;
  otp?: string;
  campaignId: string;
}

export interface CreateCampaignPoolDiscountLimits {
  limits: DiscountLimits[];
  // otpRequestId?: string;
  // otp?: string;
  campaignId: string;
}

export interface CreateCampaignTradeInDiscountLimits {
  limits: DiscountLimits[];
  otpRequestId?: string;
  otp?: string;
  campaignId: string;
}

export interface UpdateCampaignNetPriceCeiling {
  ceilingPrices?: VehiclesAndCeilingPrice[];
  otpRequestId?: string;
  otp?: string;
  campaignId: string;
}

export interface CampaignTradeInDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
  applicableOn?: DiscountApplicableOn;
}
export interface CampaignPoolDiscount {
  _id?: string;
  name: string;
  createdBy?: OwnerUser;
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
  applicableOn?: DiscountApplicableOn;
  pools?:DiscountPool[];
}

export interface CampaignNpcDiscount {
  _id?: string;
  showroomIds: string[];
  title: string;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
  applicableOn?: DiscountApplicableOn;
  ceilingPrices?: VehiclesAndCeilingPrice[];
}

export interface CreateCampaignPoolDiscount {
  pools?: DiscountPool[];
  name: string;
  campaignId?: string;
}

export interface DiscountLimit {
  _id: string;
  combination?: VehicleDiscountCombination;
  discountTypes: [
    {
      discountTypeId?: string;
      limit: number;
    }
  ];
}
export interface CashDiscountGrouped {
  upcoming: CashDiscount[];
  current: CashDiscount[];
  past: CashDiscount[];
}

export interface CreateDiscount {
  showroomIds?: string[];
  name?: string;
  startDate: Date;
  endDate: Date;
  showroom?: Showroom[];
}

export interface CreateCampaignDiscountGroup {
  showroomIds?: string[];
  name?: string;
  showroom?: Showroom[];
}

export interface CreateLimitsDiscountType {
  _id: string;
  name: string;
  limit?: number;
  modelVariants?: [{ variantCode: string; modelCode: string }];
}

export interface VehicleDiscountCombination {
  model: VehicleModelMinimal;
  variant: VehicleVariantMinimal;
  ecomId: string;
  ecomSKU: string;
  price: number;
  npc: number;
  interior: Exterior;
  exterior: Exterior;
  limits?: CreateLimitsDiscountType[];
  ceilingPrice?: number;
}

export interface DiscountLimits {
  discountTypes: [
    {
      discountTypeId?: string;
      limit: number;
    }
  ];
  combinationSku?: string;
}

export interface OtpResponse {
  _id: string;
  purpose: string;
  expiryAt: Date;
}

export interface CreateDiscountLimits {
  limits: DiscountLimits[];
  otpRequestId: string;
  otp: string;
}

export interface PoolDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  pools?: DiscountPool[];
  limits?: DiscountLimit[];
}

export interface CampaignPoolDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  pools?: DiscountPool[];
  limits?: DiscountLimit[];
}
export interface PoolDiscountGrouped {
  upcoming: PoolDiscount[];
  current: PoolDiscount[];
  past: PoolDiscount[];
}

export interface CreatePoolDiscount {
  pools?: DiscountPool[];
  name: string;
  startDate: Date;
  endDate: Date;
}

export interface DiscountPool {
  showroomId?: string;
  level: string;
  limit: number;
  discountTypeId: string;
}

export interface DiscountMasterData {
  sku: string;
  npc: number;
  maxDiscountAllowed: number;
  cash: {
    currentDiscountId: string;
    discounts: IDiscountType[];
  };
  pool: {
    currentDiscountId: string;
    discounts: IDiscountType[];
  };
  tradeIn: {
    currentDiscountId: string;
    discounts: IDiscountType[];
  };
  other: {
    currentDiscountId?: string;
    discounts: IDiscountType[];
  };
}

export interface IDiscountType {
  _id?: string;
  name: string;
  level: string;
  approverTypes: string[];
  requesterTypes: string[];
  doNotIncludeInNPC: boolean;
  autolineOptionCode: string;
  limit?: number;
  poolLimit?: number;
  documents: DiscountDocumentType[];
  requiredDocuments?: string[];
  requiredAnyOneDocument?: boolean;
  hideMaxDiscountFromUI?: boolean;
  code?: string;
  avoidMaxDiscount?: boolean;
  discountMode?: string;
  maxAllowedDiscountValue?: number;
}

export interface CreateApplyDiscount {
  discountMode?: string;
  discountTypeId?: string;
  discount?: number;
  comments?: string;
  documents?: {
    documentTypeId: string;
    side: number;
    document: MediaFile;
    name?: string;
  }[];
  tradeInId?: string;
  donotAppliedToInsurance?: boolean;
}

export interface CreateApplyOtherDiscount {
  discountMode?: string;
  discountTypeId?: string;
  discount?: number;
  comments?: string;
  documents?: {
    documentTypeId: string;
    side: number;
    document: MediaFile;
    name?: string;
  }[];
  tradeInId?: string;
  otherDiscountType?: string;
}

export interface Discount {
  _id?: string;
  showroomIds: string[];
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  pools?: DiscountPool[];
  limits?: DiscountLimit[];
  applicableOn?: DiscountApplicableOn;
}

export interface TradeInDiscountGrouped {
  upcoming: TradeInDiscount[];
  current: TradeInDiscount[];
  past: TradeInDiscount[];
}

export interface TradeInDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
}

export interface CampaignTradeInDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  limits?: DiscountLimit[];
}

export interface CombinedDiscountTypeLimit {
  _id?: string;
  discountTypes: DiscountType[];
  limit: number;
  limits?: CombinedDiscountLimit[];
}

export interface CombinedDiscountLimit {
  _id: string;
  combination?: CombinedDiscountCombination;
  limit: number;
}

export interface CombinedDiscount {
  _id?: string;
  showroomIds: string[];
  name: string;
  startDate: Date;
  endDate: Date;
  createdBy?: OwnerUser;
  showrooms?: Showroom[];
  createdAt: Date;
  updatedAt: Date;
  discountTypeLimits?: CombinedDiscountTypeLimit[];
}

export interface CombinedDiscountCombination {
  model: VehicleModelMinimal;
  variant: VehicleVariantMinimal;
  ecomId: string;
  ecomSKU: string;
  price: number;
  interior: Exterior;
  exterior: Exterior;
  limit?: number;
}

export interface CombinedDiscountGrouped {
  upcoming: CombinedDiscount[];
  current: CombinedDiscount[];
  past: CombinedDiscount[];
}

export interface CreateCombinedDiscountLimit {
  discountMode: string;
  discountType: DiscountType;
}

export interface CreateCombinedDiscountLimits {
  limits: CombinedDiscountLimit[];
  otpRequestId: string;
  otp: string;
  _id: string;
}
